<template lang="html">
    <div class="row">
        <order-receipt-email-modal :show="show"/>

        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="card-title mb-4">Orders</h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <b-input-group size="md">
                                <a-date-picker format="DD/MM/YYYY" @change="handleDateChanged"/> 
                            </b-input-group>
                        </div>
                        <div class="col-md-3">
                            <b-input-group size="md">
                                <a-week-picker placeholder="Select week" @change="handleWeekChanged"/> 
                            </b-input-group>
                        </div>
                        <div class="col-md-3">
                            <b-input-group size="md">
                                 <a-month-picker placeholder="Select month" @change="handleMonthChanged"/>  
                            </b-input-group>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-6">
                            <h5 class="card-title mb-4">Total Amount: {{ totalAmount }} </h5>
                        </div>
                        <div class="col-md-6">
                            <h5 class="card-title mb-4">Total Orders : {{ totalOrders }} </h5>
                        </div>
                    </div>
                    <br>
                    <div class="table-responsive">
                        <table class="table center-aligned-table">
                            <thead>
                                <tr>
                                    <th class="border-bottom-0">No.</th>
                                    <th class="border-bottom-0">Created Date</th>
                                    <th class="border-bottom-0">Order Id</th>
                                    <th class="border-bottom-0">Customer</th>
                                    <th class="border-bottom-0">Total</th>
                                    <th class="border-bottom-0">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(o, index) in orders">
                                    <tr>
                                        <td> {{ index + 1 }} </td>
                                        <td> {{ formatDate(o.createdDate) }} </td>
                                        <td> {{ o.orderId }} </td>
                                        <td> {{ o.customerName }} </td>
                                        <td> {{ getOrderTotal(o) }} </td>
                                        <td>
                                            <div class="btn-group">
                                                <button type="button" 
                                                        class="btn btn-sm btn-outline-secondary"
                                                         v-b-toggle="index.toString()">
                                                        <i class="mdi mdi-information text-primary"></i>View
                                                </button>
                                                <b-dropdown class="btn btn-sm btn-outline-secondary"
                                                            text="Other">
                                                    <b-dropdown-item @click="openModal(o.orderId)">
                                                        Send Receipt
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </div>       
                                        </td>  
                                    </tr>
                                    <tr>
                                        <td colspan="8">
                                            <b-collapse :id="index.toString()" 
                                                        class="mt-2">
                                                <b-card>
                                                    <b-table striped hover :items="o.orderDetails"
                                                                            :fields="fields">
                                                    </b-table>
                                                </b-card>
                                            </b-collapse> 
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
import Datepicker from 'vuejs-datepicker'
import { mapState, mapGetters } from'vuex'
import RestaurantChangedBase from '../Bases/RestaurantChangedBase'
import TimeFormatter from '../../../src/assets/js/TimeFormatter'
import OrderReceiptEmailModal from './OrderReceiptEmailModal.vue'
export default{
    name: 'orders',
    extends: RestaurantChangedBase,
    components : {
        Datepicker,
        OrderReceiptEmailModal
    },
    data () {
        return {
            fields : ['itemName', 'quantity', 'itemPrice', 'categoryName'],
            show : false,
            dismissSecs: 10
        }
    },
    computed: {
        ...mapState({
            orders : state => state.orders.orders
        }),
        ...mapGetters({
            totalOrders : 'orders/totalOrders',
            totalAmount : 'orders/totalAmount'
        })
    },
    methods: {
        getOrderTotal(order) {
            let total = 0;
            order.orderDetails.forEach(o => {
                total += o.itemPrice * o.quantity;
            })
            return total + ' kr';
        },
        formatDate(dateString) {
            return this.$moment(dateString).format('D-MM-YYYY');
        },
        async handleDateChanged(date, dateString) {
            //console.log(dateString.replace('/','').replace('/',''));
            let selectedDate = dateString.replace('/','').replace('/','');
            await this.$store.dispatch('orders/getOrdersByDateAction', selectedDate);
        },
        handleMonthChanged(date, dateString) {
            //console.log(dateString.replace('/','').replace('/',''));
            console.log(date, dateString);
        },
        handleWeekChanged() {

        },
        openModal(orderId) {
            this.eventBus.$emit("OrderReceiptEmailModalOpenedEvent",orderId);
        },
        showSuccessSentReceiptToMail() {

        },
        showFaiedSentReceiptToMail() {

        }

    },
    created () {
        //this.eventBus.$on('OrderReceiptEmailModalClosedEvent', this.closeModalHandler);
    },
    destroyed () {
        //this.eventBus.$off('OrderReceiptEmailModalClosedEvent', this.closeModalHandler);
    }
}
</script>

<style lang="scss">
   
</style>